import React from 'react';
import { Divider as DividerTpa } from 'wix-ui-tpa/Divider';
import { st, classes } from './Divider.st.css';

type Props = React.ComponentProps<typeof DividerTpa>;

export const Divider = (props: Props) => <DividerTpa className={st(classes.root, {}, props.className)} {...props} />;
